/**
 * Initializes Firebase Realtime Database and provides a function to fetch data.
 *
 * @module
 * @description This module configures Firebase with the given credentials, initializes the Realtime Database,
 * and provides a function to fetch data from a specific reference.
 * 
 * @constant {Object} firebaseConfig2 - Firebase configuration object with necessary credentials.
 * @constant {FirebaseApp} rtdbApp - Initialized Firebase application instance for Realtime Database.
 * @constant {Database} database - Firebase Realtime Database instance.
 * 
 * @function fetchData - Fetches data from the "auctions" reference in the Firebase Realtime Database.
 * @async
 * @returns {Promise<void>} A promise that resolves when the data fetching is complete.
 * @throws Will throw an error if there is an issue with fetching data from Firebase.
 */
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase, ref, onValue } from "firebase/database";
import {
  RTDB_API_KEY,
  RTDB_AUTH_DOMAIN,
  RTDB_API_KEY_DB_URL,
  RTDB_API_KEY_PRODUCT_ID,
  RTDB_API_KEY_STORAGE_BUCKET,
  RTDB_API_KEY_SENDER_ID,
  RTDB_API_KEY_APP_ID
} from '../Constants';

const firebaseConfig = {
  apiKey: RTDB_API_KEY,
  authDomain: RTDB_AUTH_DOMAIN,
  databaseURL: RTDB_API_KEY_DB_URL,
  projectId: RTDB_API_KEY_PRODUCT_ID,
  storageBucket: RTDB_API_KEY_STORAGE_BUCKET,
  messagingSenderId: RTDB_API_KEY_SENDER_ID,
  appId: RTDB_API_KEY_APP_ID,
};
const rtdbApp = initializeApp(firebaseConfig, "rtdb");
const database = getDatabase(rtdbApp);
const tpmpAuth =getAuth(rtdbApp)

// console.log(database); // Check if database object is correct

/**
 * Fetches data from the "auctions" reference in the Firebase Realtime Database.
 * 
 * @async
 * @function fetchData
 * @returns {Promise<void>} A promise that resolves when the data fetching is complete.
 * @throws Will throw an error if there is an issue with fetching data from Firebase.
 */
const fetchData = async () => {
  try {
    const auctionsRef = ref(database, "auctions");

    onValue(auctionsRef, (snapshot) => {
      // const data = snapshot.val();

      // console.log(data, "data from snapshot");
    });
  } catch (error) {
    console.error(
      "Error fetching data from Firebase Realtime Database:",
      error
    );
  }
};

export { database, fetchData,tpmpAuth };
